import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import { useApp } from "@/context/AppProviders";
import Header from "@/components/landing/Header";
import Footer from "@/components/landing/Footer";

const ThankYou = () => {
  const { t } = useApp();
  const s = t.shop;
  return (
    <div className="min-h-screen bg-background text-foreground font-body antialiased">
      <Header />
      <main className="pt-28 pb-24">
        <div className="max-w-2xl mx-auto px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.4 }}
            className="mx-auto flex h-16 w-16 items-center justify-center rounded-full border border-blue-600/40 bg-blue-600/10"
          >
            <CheckCircle2 className="h-8 w-8 text-blue-500" />
          </motion.div>
          <h1
            data-testid="thankyou-title"
            className="font-heading mt-6 text-3xl sm:text-4xl font-bold tracking-tight"
          >
            {s.thankTitle}
          </h1>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            {s.thankBody}
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/activate-help"
              data-testid="thankyou-activate"
              className="inline-flex h-11 items-center justify-center gap-1.5 rounded-sm bg-blue-600 px-5 text-sm font-medium text-white hover:bg-blue-500"
            >
              {s.thankActivate}
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/"
              className="inline-flex h-11 items-center justify-center rounded-sm border border-border bg-secondary/50 px-5 text-sm font-medium hover:bg-secondary"
            >
              {s.thankHome}
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default ThankYou;
